import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import axios from 'axios';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import { Modal, Button, Popover, Overlay } from 'react-bootstrap';
import {
  getUserDetails,
  getTokenId,
  getJWT,
} from '../../../redux/reducers/authenticationReducers';
import {
  updateMealPlan,
  updateGuestUser,
  removeGuestUser,
} from '../../../redux/actions/authenticationActions';
import {
  emptyCart,
  parseStartTimeEndTime,
  setPaymentModeDashboard,
  locationDetails,
  resetPostCheckout,
  refreshTaxDetails,
  restoreTaxDetails,
  convertTime,
  setOrderTimeIsValidState,
  orderTime as setOrderTime,
  showMobileSidebar,
  updatingTax,
  getTimings,
} from '../../dashboard/actions';
import {
  getDashboardData,
  getRestaurantDetails,
  getOrderDetails,
  isDataNameFilterForDining,
  isPaymentUponRecieptOnly,
  isPrepayOnly,
  isNotValidPaymentOptions,
} from '../../dashboard/reducer';
import { setLoyalityCardData } from '../actions';
import { checkoutData } from '../reducer';
import { ToastContainer, ToastMessage } from '../../../lib';
import { MEAL_PLAN } from '../../../util/avialableRoutes';
import {
  Email,
  Required,
  Mobile,
  onServerError,
  testRegex,
  checkNumber,
} from '../../../lib/validator.js';
import {
  GetCartItems,
  GetOrderType,
  getCartPriceDetails,
  getAlertifyHeader,
  parsePrice,
  API_ERROR,
  formattedAddress,
  cookieValue,
} from '../../../lib/helper.js';
import Footer from '../../../Footer';
import {
  BRIDGEPAY_URL,
  DELIVERY_ADDRESS_URL,
  GIFT_CARD_URL,
  LOYALTY_POINTS_URL,
  ORDER_PAYPAL_WALLET,
} from '../../../util/urls';
import { BUFFER_TIME } from '../../../util/Constants';
import {
  requestHeaders,
  updateCartDetails,
  getMealPlanDetails,
  getItemTaxes,
} from '../../../api/api';
import OutOfStockItems from '../../inventory/OutOfStockItems';
import ErrorMessage from './ErrorMessage';
import AwardPointModal from './AwardPointModal.jsx';
import GiftCardModal from './GiftCardModal';
import OrderDateAndTime from './OrderDateAndTime';

import { get } from 'lodash';
import defaultMsg from '../../../translations/lang/en-US.json';
import { MdLoaderTheme, MdLoaderWhite } from '../../common/Loading';
import { isRestaurantAvailable, isAvailableNow } from '../../../lib/helper';
import {
  MODIFIER_FORCED,
  MODIFIER_OPTIONAL,
  MODIFIER_DETOR,
} from '../../../util/Constants';

let feedbackLink;
let displayRestaurantInfo;
const ToastMessageFactory = React.createFactory(ToastMessage.animation);
const dropin = require('braintree-web-drop-in');
let alertify = require('alertifyjs');
alertify.dialog('orderSuccessWithRestaurantInfo', function factory() {
  return {
    main: function(title, message, onOk, onRestaurantInfo) {
      this.message = message;
      this.title = title;
      this.onOk = onOk;
      this.onRestaurantInfo = onRestaurantInfo;
    },
    setup: function() {
      let buttons = [];
      if (feedbackLink && displayRestaurantInfo) {
        buttons.push({
          text: feedbackLink,
          className: 'btn btn-restaurant-info bordered',
        });
      } else {
        buttons.push({
          text: JSON.parse(localStorage.getItem('langVars'))[
            'contactRestaurant'
          ],
          className: 'btn btn-restaurant-info bordered',
        });
      }
      buttons.push({
        text: JSON.parse(localStorage.getItem('langVars'))['ok'],
        key: 27,
        className: 'btn btn-ok bordered',
        invokeOnClose: false,
      });
      return {
        buttons,
        options: {
          resizable: false,
          moveable: false,
          pinned: false,
          maximizable: false,
          closable: false,
        },
      };
    },
    prepare: function() {
      this.setHeader(this.title);
      this.setContent(this.message);
    },
    callback: function(action) {
      if (action.index === 0) {
        action.cancel = true;
        if (feedbackLink && displayRestaurantInfo) {
          var feedbackString = feedbackLink
            .substring(
              feedbackLink.lastIndexOf('href='),
              feedbackLink.lastIndexOf('"')
            )
            .split('"')[1]
            .trim()
            .replace(/['"]+/g, '');
          window.open(feedbackString, '_blank');
        } else {
          this.onRestaurantInfo();
        }
      } else if (this.onOk) {
        this.onOk();
      }
    },
  };
});
alertify.dialog('orderSuccess', function factory() {
  return {
    main: function(title, message, onOk) {
      this.message = message;
      this.title = title;
      this.onOk = onOk;
    },
    setup: function() {
      var buttons = [];
      if (feedbackLink) {
        buttons.push({
          text: feedbackLink,
          className: 'btn btn-restaurant-info bordered',
        });
      }
      buttons.push({
        text: JSON.parse(localStorage.getItem('langVars'))['ok'],
        key: 27,
        className: 'btn btn-ok bordered',
        invokeOnClose: false,
      });
      return {
        buttons,
        options: {
          resizable: false,
          moveable: false,
          pinned: false,
          maximizable: false,
          closable: false,
          closableByDimmer: false,
        },
      };
    },
    prepare: function() {
      this.setHeader(this.title);
      this.setContent(this.message);
    },
    callback: function(action) {
      if (action.index === 0) {
        action.cancel = true;
        if (feedbackLink && displayRestaurantInfo) {
          var feedbackString = feedbackLink
            .substring(
              feedbackLink.lastIndexOf('href='),
              feedbackLink.lastIndexOf('"')
            )
            .split('"')[1]
            .trim()
            .replace(/['"]+/g, '');
          window.open(feedbackString, '_blank');
        } else {
          this.onOk();
        }
      } else if (this.onOk) {
        this.onOk();
      }
    },
  };
});

const tipType = {
  custom: 'custom',
  notip: 'notip',
};
const loadingStates = {
  paypal: 'paypal',
  loyality: 'loyality',
};
class PlaceOrder extends React.Component {
  constructor(props) {
    super(props);
    const weekDayConfiguration = JSON.parse(
      this.props.dashboardData.merchantDetails.ltg_start_end_time
    );
    const { currentTimeCompare, isNowAvialable } = this.isNowAvialable();
    const orderTimeDetails = this.getOrderDateAndTime(weekDayConfiguration);
    this.props.dispatch(setOrderTime(orderTimeDetails.time));
    const cartSplit = getCartPriceDetails(this.props, false);
    this.state = {
      paymentMode: '',
      tip: '',
      check: false,
      delAdrInvalid: false,
      addTip: this.getTipeType(),
      loyaltyCardModal: false,
      loyaltyCardData: '',
      showLoyaltyPopover: false,
      loyaltyDiscountId: '',
      awardPointModal: false,
      giftCardData: '',
      phonenumber: this.getUserInfo('mobile'),
      email: this.getUserInfo('email'),
      firstName: this.getUserInfo('firstName'),
      lastName: this.getUserInfo('lastName'),
      instructions: '',
      loginUpdate: this.props.loginUserDetails ? true : false,
      giftCardModal: false,
      cartSplit: cartSplit,
      loading: false,
      placingOrder: false,
      checkingOut: false,
      paymentReady: false,
      showOutOfStock: false,
      orderDate: orderTimeDetails.date,
      orderTime: orderTimeDetails.time,
      customTip: cartSplit.tip.price,
      interval: 1000,
      filteredDate: orderTimeDetails.filteredDate,
      restaurantClosed: orderTimeDetails.restaurantClosed,
      weekDayConfiguration,
      istimeUpdated: orderTimeDetails.istimeUpdated,
      firstNameError: false,
      lastNameError: false,
      emailError: false,
      phoneNoError: false,
      scrollBottom: false,
      enableMealPlanButton: false,
      instructionsError: false,
      updatingPayment: false,
      currentTimeCompare,
      isNowAvialable,
    };
    this.customTipChange = this.customTipChange.bind(this);
    this.phoneNumberOnchange = this.phoneNumberOnchange.bind(this);
    this.firstNameOnchange = this.firstNameOnchange.bind(this);
    this.lastNameOnchange = this.lastNameOnchange.bind(this);
    this.emailOnchange = this.emailOnchange.bind(this);
    this.instructionsOnchange = this.instructionsOnchange.bind(this);
    this.handlePaypalCheckout = this.handlePaypalCheckout.bind(this);
    this.getReqestParams = this.getReqestParams.bind(this);
    this.getOrderDateAndTime = this.getOrderDateAndTime.bind(this);
    this.validateTip = this.validateTip.bind(this);
    this.proccedToCheckout = this.proccedToCheckout.bind(this);
    this.hideInventoryOutOfStock = this.hideInventoryOutOfStock.bind(this);
    this.checkAndUpdateTime = this.checkAndUpdateTime.bind(this);
    this.displayOrderTime = this.displayOrderTime.bind(this);
    this.storeLoyaltyData = this.storeLoyaltyData.bind(this);
    this.getTipeType = this.getTipeType.bind(this);
    this.isDiscountAvailable = this.isDiscountAvailable.bind(this);
    this.clearDiscount = this.clearDiscount.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
    this.openCart = this.openCart.bind(this);
    this.orderSuccessMessage = this.orderSuccessMessage.bind(this);
    this.handleLoyaltyCardChange = this.handleLoyaltyCardChange.bind(this);
    feedbackLink = this.props.dashboardData.merchantDetails
      .ltg_on_embed_typform_feedback;
    this.scrollToElement = this.scrollToElement.bind(this);
    displayRestaurantInfo = this.props.dashboardData.merchantDetails
      .ltg_on_checkout_display_restaurant_info;
  }

  getCurrentDate = () => Number(moment().format('x'));

  isNowAvialable() {
    const {
      restaurantDetails: { hoursOfOperation, minAdvanceNoticeTime },
    } = this.props;
    const currentDate = this.getCurrentDate();
    const weekDayConfigurationForToday = parseStartTimeEndTime(
      hoursOfOperation,
      currentDate
    );
    const dayTimings = !isEmpty(weekDayConfigurationForToday)
      ? weekDayConfigurationForToday.map(config =>
          getTimings(
            minAdvanceNoticeTime,
            currentDate,
            config.starttime,
            config.endtime,
            true,
            true
          )
        )
      : [false];

    let endTimePresent = null;
    if (weekDayConfigurationForToday && weekDayConfigurationForToday.length) {
      const splitEndTime = weekDayConfigurationForToday[0].endtime.split(':');
      endTimePresent = Number(splitEndTime[0]) * 60 + Number(splitEndTime[1]);
    }

    var currentTime = moment().get('hours') * 60 + moment().get('minutes');
    return {
      currentTimeCompare:
        endTimePresent !== null && parseFloat(endTimePresent - currentTime) > 0
          ? true
          : false,
      isNowAvialable: dayTimings && dayTimings.indexOf(true) !== -1,
    };
  }

  orderSuccessMessage(
    { msg, order_id },
    { dining_date, dining_time, order_type },
    callBack
  ) {
    dining_time =
      this.props.dashboardData.modeOfOrder === 2
        ? this.props.dashboardData.locationDetails.deliveryTime
        : moment(dining_time, 'HH:mm:ss').format('hh:mm A');
    const restaurantContactInfo = props => {
      const { restaurantContactInformation, locationDetails } = props;
      var showRestaurantInfo = '';
      if (feedbackLink && displayRestaurantInfo) {
        showRestaurantInfo = '';
      } else {
        showRestaurantInfo = 'restaurant-information';
      }
      return `
          <div id="restaurant-information"   class="${showRestaurantInfo} transition hide-info">
            <div class="restaurant-modal-title">
              <b>${restaurantContactInformation.title}</b>
            </div>
            <div class="restaurant-address">${formattedAddress(
              locationDetails
            )}</div>
            <div class="restaurant-email">${
              restaurantContactInformation.email
            }</div>
            <div class="restaurant-contact-no">${
              restaurantContactInformation.phone
            }</div>
          </div>
        `;
    };

    const messageBody = `
      <div class="text-center order-success-container">
        <h5 class="success-message">${msg}</h5>
        <h3 class="order-id-title">
        ${this.props.intl.formatMessage({
          id: 'orderId',
          defaultMessage: defaultMsg.orderId,
        })} : ${order_id}
        </h3>
        <div class="order-type-date">
        ${this.props.intl.formatMessage({
          id: 'orderType',
          defaultMessage: defaultMsg.orderType,
        })} : ${order_type},
        ${this.props.intl.formatMessage({
          id: 'onDate',
          defaultMessage: defaultMsg.onDate,
        })} : ${moment(dining_date, 'YYYY-MM-DD').format('MMM D, Y') +
      ' ' +
      dining_time}
        </div>
        ${
          this.props.restaurantDetails.isOnCheckOutDisplayRestaurantInfo ===
          true
            ? restaurantContactInfo(this.props.dashboardData)
            : ''
        }
      </div>
    `;

    if (
      this.props.restaurantDetails.isOnCheckOutDisplayRestaurantInfo === true
    ) {
      alertify.orderSuccessWithRestaurantInfo(
        getAlertifyHeader(
          JSON.parse(localStorage.getItem('langVars'))['success'],
          false,
          'center'
        ),
        messageBody,
        callBack,
        function() {
          const element = document.getElementById('restaurant-information')
            .classList;
          if (element.contains('restaurant-information')) {
            element.remove('restaurant-information');
          } else {
            element.add('restaurant-information');
          }
        }
      );
    } else {
      alertify
        .orderSuccess(
          getAlertifyHeader(
            JSON.parse(localStorage.getItem('langVars'))['success'],
            false,
            'center'
          ),
          messageBody,
          callBack
        )
        .set('closable', false);
    }
  }

  openCart() {
    this.props.dispatch(showMobileSidebar());
  }

  getUserInfo(type) {
    let cookieData = cookieValue('token');
    if (cookieData === null) {
      return this.props.loginUserDetails &&
        this.props.loginUserDetails.guestUser &&
        this.props.loginUserDetails.guestUser !== null
        ? this.props.loginUserDetails.guestUser[type]
        : '';
    } else {
      return this.props.loginUserDetails && this.props.loginUserDetails !== null
        ? this.props.loginUserDetails[type]
        : '';
    }
  }

  clearDiscount() {
    this.setState({
      loyaltyCardData: '',
      loyaltyDiscountId: '',
      loyaltyCardModal: false,
      showLoyaltyPopover: false,
      awardPointModal: false,
    });
    this.props.loyaltyDiscount('');
    this.props.dispatch(updatingTax(true)).then(() => {
      this.reloadTaxes().then(response => {
        this.refreshTaxDetails(response.data.DataResponse.taxdetails);
        this.props.dispatch(updatingTax(false));
      });
    });
  }

  reloadTaxes() {
    const { orderDetails, tokenId, jwt, dataname } = this.props;
    return getItemTaxes({
      cart_contents: GetCartItems([...orderDetails.items]),
      dataname,
      tokenId,
      jwt,
    });
  }

  getTipeType() {
    switch (this.props.dashboardData.tipType) {
      case 'C':
        return tipType.custom;
      case 'P':
        return this.props.dashboardData.tipPercent.toString();
      default:
        return tipType.notip;
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      lavuDisplayType = false,
      cardNumber = false,
      discount_id = 0,
    } = nextProps.discount;
    const { updatingTaxes } = nextProps.dashboardData;
    const { loyalityCardData } = nextProps.checkoutData;
    switch (lavuDisplayType) {
      case 'awardpoints':
        if (updatingTaxes === true && cardNumber) {
          this.refs.cardNumber.value = cardNumber;
          this.setState({ loading: loadingStates['loyality'] });
          const cartSplit = getCartPriceDetails(nextProps);
          updateCartDetails({
            order_id: nextProps.dashboardData.orderIdDetails.order_id,
            user_id: get(nextProps, 'loginUserDetails.id', 0),
            order_type: GetOrderType(nextProps.dashboardData.modeOfOrder),
            delivery_fee: cartSplit.deliveryFee,
            cart_contents: GetCartItems(nextProps.orderItems),
            dataname: nextProps.dashboardData.dataName,
            tokenId: nextProps.tokenId,
            jwt: nextProps.jwt,
            locationid: nextProps.dashboardData.merchantDetails.locationid,
          }).then(response => {
            this.handleLoyaltyPoint(true);
          });
        }
        break;

      case 'discount':
        if (updatingTaxes === true && discount_id && cardNumber) {
          this.setState({
            loyaltyCardData: loyalityCardData,
          });
          this.storeLoyaltyData(nextProps.discount, nextProps);
        }
        break;
      default:
        break;
    }

    if (!this.interval) {
      this.interval = setInterval(this.checkAndUpdateTime, this.state.interval);
    }
  }
  componentWillMount() {
    this.props.dispatch(setPaymentModeDashboard(''));
    if (this.state.restaurantClosed) {
      this.props.dispatch(setOrderTimeIsValidState(false));
    } else {
      this.props.dispatch(setOrderTimeIsValidState(true));
    }
  }
  componentDidMount() {
    if (this.props.dashboardData.modeOfOrder !== 2) {
      this.interval = setInterval(this.checkAndUpdateTime, this.state.interval);
    }

    if (
      this.props.loginUserDetails &&
      this.props.loginUserDetails['mealPlanUserId'] &&
      this.props.isPrepayOnly
    ) {
      this.setState({
        updatingPayment: true,
      });
      getMealPlanDetails({
        userId: this.props.loginUserDetails['mealPlanUserId'],
        dataname: this.props.dashboardData.dataName,
        jwt: this.props.jwt,
        tokenId: this.props.tokenId,
      }).then(response => {
        if (response.data.DataResponse.mealPlanEnable === 'true') {
          this.props.dispatch(updateMealPlan(response.data.DataResponse));
          this.setState({
            enableMealPlanButton: true,
            updatingPayment: false,
          });
        } else {
          this.setState({
            enableMealPlanButton: false,
            updatingPayment: false,
          });
        }
        this.autoTiggerPaymentOption();
      });
    } else {
      this.autoTiggerPaymentOption();
    }
    if (
      this.props.loginUserDetails &&
      this.props.loginUserDetails['mealPlanUserId']
    ) {
      getMealPlanDetails({
        userId: this.props.loginUserDetails['mealPlanUserId'],
        dataname: this.props.dashboardData.dataName,
        jwt: this.props.jwt,
        tokenId: this.props.tokenId,
      }).then(response => {
        if (response.data.DataResponse.mealPlanEnable === 'true') {
          this.props.dispatch(updateMealPlan(response.data.DataResponse));
          this.setState({
            enableMealPlanButton: true,
          });
        } else {
          this.setState({
            enableMealPlanButton: false,
          });
        }
      });
    }
    // this.setupPaymentDetails();
  }
  componentDidUpdate(prevProps, prevState) {
    document.title =
      this.props.intl.formatMessage({
        id: 'titleBarPlaceOrder',
        defaultMessage: defaultMsg.titleBarPlaceOrder,
      }) +
      ` - ${this.props.dashboardData.merchantDetails.title} - ` +
      this.props.intl.formatMessage({
        id: 'titleBarLavuTogo',
        defaultMessage: defaultMsg.titleBarLavuTogo,
      });
    this.updateUserLoginDetails();
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setupPaymentDetails = () => {
    const {
      restaurantDetails: { isPayPalEnabled, paypalSandboxToken },
      asapTimeAvailability,
      maxAdvanceDays,
    } = this.props;
    const { currentTimeCompare, isNowAvialable } = this.state;
    if (
      // this.state.paymentMode === 'paypal' &&
      // this.state.loading === loadingStates['paypal'] &&
      isPayPalEnabled &&
      paypalSandboxToken &&
      ((currentTimeCompare === true &&
        isNowAvialable &&
        asapTimeAvailability === '1') ||
        (currentTimeCompare === true && asapTimeAvailability === '0') ||
        maxAdvanceDays !== '0')
    ) {
      document.getElementById('dropin-container').innerHTML = '';
      this.setState({
        loading: loadingStates['paypal'],
        paypalPaymentError: false,
      });
      dropin.create(
        {
          authorization: paypalSandboxToken,
          container: '#dropin-container',
          card: {
            cardholderName: {
              required: true,
            },
          },
        },
        (createErr, instance) => {
          if (instance) {
            instance.on('paymentMethodRequestable', () => {
              this.setState({ paymentReady: true });
            });

            instance.on('noPaymentMethodRequestable', () => {
              this.setState({ paymentReady: false });
            });
            let button = document.getElementById('submit-button');
            if (button) {
              button.addEventListener('click', e => {
                e.preventDefault();
                if (this.validateOrder()) {
                  this.handlePaypalCheckout(instance, e);
                }
              });
            }
            if (createErr) {
              this.refs.checkout_container.error(createErr.message);
              this.setState({
                paypalPaymentError: true,
                loading: false,
              });
              return;
            }
            this.setState({
              loading: false,
              paypalPaymentError: false,
              paymentReady: !!instance.isPaymentMethodRequestable(),
            });
          } else {
            this.setState({
              paypalPaymentError: true,
              loading: false,
            });
          }
        }
      );
    } else {
      this.scrollBottom();
    }
  };

  checkAndUpdateTime() {
    const orderTimeDetails = this.getOrderDateAndTime(
      this.state.weekDayConfiguration
    );
    const {
      date: orderDate,
      time: orderTime,
      filteredDate,
      istimeUpdated,
    } = orderTimeDetails;
    const { dashboardData } = this.props;
    const restaurantClosed = get(orderTimeDetails, 'restaurantClosed', false);

    this.setState({
      orderDate,
      orderTime,
      filteredDate,
      restaurantClosed,
      istimeUpdated,
    });

    if (
      orderTimeDetails.istimeUpdated ||
      (dashboardData.orderDate === 'now' &&
        dashboardData.orderTime !== orderTime)
    ) {
      this.props.dispatch(setOrderTime(orderTime));
    }

    if (restaurantClosed === true) {
      this.props.dispatch(setOrderTimeIsValidState(false));
      clearInterval(this.interval);
    }
  }

  autoTiggerPaymentOption = () => {
    const {
      restaurantDetails: { paypalSandboxToken, isPayPalEnabled },
      dashboardData: { modeOfOrder },
      isPaymentUponRecieptOnly,
      isPrepayOnly,
    } = this.props;
    const { paymentMode, enableMealPlanButton } = this.state;
    if (paypalSandboxToken && isPayPalEnabled && this.isCardOptionEnabled()) {
      this.handlePaymentMode('paypal', false);
    } else if (
      (paymentMode === 'cod' || Number(modeOfOrder)) &&
      this.props.isPaymentUponRecieptOnly
    ) {
      this.handlePaymentMode('cod', false);
    } else if (isPrepayOnly && enableMealPlanButton) {
      this.handlePaymentMode('meal_plan', false);
    }
  };

  hideInventoryOutOfStock() {
    this.setState({
      showOutOfStock: false,
    });
  }

  proccedToCheckout() {
    const { paymentMode } = this.state;
    if (this.validateOrder()) {
      switch (paymentMode) {
        case 'cod':
          if (this.payWithCash) {
            this.payWithCash.click();
          }
          break;
        case 'paypal':
          if (this.payWithPayPal) {
            this.payWithPayPal.click();
          }
          break;
        default:
          break;
      }
    }
  }

  validateTip() {
    if (this.state.addTip === 'custom') {
      return this.state.customTip.toString().replace(/[0.,\t\s]/g, '').length >
        0
        ? true
        : false;
    } else {
      return true;
    }
  }

  updateUserLoginDetails() {
    if (this.props.loginUserDetails && this.state.loginUpdate === false) {
      this.setState({
        phonenumber: this.getUserInfo('mobile'),
        email: this.getUserInfo('email'),
        firstName: this.getUserInfo('firstName'),
        lastName: this.getUserInfo('lastName'),
        loginUpdate: true,
      });
    }
  }

  checkRestaurantStatus = ({
    weekDayConfiguration,
    timeStamp,
    orderDate,
    strictChecking = true,
  }) => {
    const parsedTimings = parseStartTimeEndTime(
      weekDayConfiguration,
      timeStamp
    );
    if (parsedTimings) {
      let statuses = parsedTimings.map(config =>
        this.isRestaurantClosed(
          orderDate,
          config.endtime,
          config.starttime,
          strictChecking
        )
      );
      return statuses.indexOf(false) !== -1
        ? !strictChecking
          ? false
          : true
        : true;
    } else {
      return true;
    }
  };

  getOrderDateAndTime(config) {
    let orderDate,
      orderTime,
      filteredDate,
      istimeUpdated = false;
    let now = moment();
    let weekDayConfiguration = Object.assign({}, config);
    const currentDate = `${now.get('date')}${now.get('month')}${now.get(
      'year'
    )}`;
    const bufferTime =
      Number(
        get(this.props, 'dashboardData.merchantDetails.minimum_notice_time', 0)
      ) + BUFFER_TIME;

    if (this.props.dashboardData.orderDate === 'now') {
      const timeStamp = Number(moment().format('x'));
      now = now.add(bufferTime, 'minutes');
      filteredDate = now.format('MMM D, Y hh:mm A');
      orderDate = now.format('MMM DD, YYYY');
      orderTime = now.format('hh:mm A');
      if (
        this.checkRestaurantStatus({
          weekDayConfiguration,
          timeStamp,
          orderDate: now,
          strictChecking: false,
        })
      ) {
        return {
          restaurantClosed: true,
        };
      }
    } else if (
      this.props.dashboardData.modeOfOrder !== 2 &&
      this.props.dashboardData.orderTime
    ) {
      const twentyfourHourTime = convertTime(
        this.props.dashboardData.orderTime,
        false,
        true
      );
      orderDate = moment(this.props.dashboardData.orderDate, 'x')
        .set(
          'hours',
          twentyfourHourTime.hours === '24' ? 0 : twentyfourHourTime.hours
        )
        .set('minutes', twentyfourHourTime.minutes);
      const selectedOrderDate = `${orderDate.get('date')}${orderDate.get(
        'month'
      )}${orderDate.get('year')}`;
      if (currentDate === selectedOrderDate) {
        const selectedTimeInMinutes =
          orderDate.get('minutes') + orderDate.get('hours') * 60;
        const currentTimeRunning = now.get('minutes') + now.get('hours') * 60;
        const collapsedTime = currentTimeRunning - selectedTimeInMinutes;
        const isInBufferSpan = selectedTimeInMinutes - currentTimeRunning;

        // look for current time collapased
        // this is will match rarely b'coz if current time is in buffer span time is automatically updated also
        // this might help on reload of checkout page
        if (collapsedTime >= 0) {
          istimeUpdated = true;
          orderDate = orderDate.add(bufferTime + collapsedTime, 'minutes');
        } else if (isInBufferSpan >= 0 && isInBufferSpan < bufferTime) {
          // increase time if current time in buffer span
          istimeUpdated = true;
          orderDate = orderDate.add(bufferTime - isInBufferSpan, 'minutes');
        }

        if (
          this.checkRestaurantStatus({
            weekDayConfiguration,
            timeStamp: Number(orderDate.format('x')),
            orderDate,
            strictChecking: false,
          })
        ) {
          return {
            restaurantClosed: true,
          };
        }
      } else if (
        now.get('date') > orderDate.get('date') &&
        now.get('month') === orderDate.get('month')
      ) {
        // look if he went to next day
        return {
          restaurantClosed: true,
        };
      }
      filteredDate = orderDate.format('MMM D, Y hh:mm A');
      orderTime = orderDate.format('hh:mm A');
      orderDate = orderDate.format('MMM DD, YYYY');
    }
    return {
      date: orderDate,
      time: orderTime,
      filteredDate: filteredDate,
      restaurantClosed: false,
      istimeUpdated: istimeUpdated,
    };
  }

  getTimeInMinutes(timing) {
    const time = timing.split(':');
    return Number(time[0]) * 60 + Number(time[1]);
  }

  isRestaurantClosed(orderDate, endtime, starttime, strictChecking) {
    const now = moment();
    const currentTimeRunning = now.get('minutes') + now.get('hours') * 60;
    const closingTimeMinutes = this.getTimeInMinutes(endtime);
    const orderDateInMinutes =
      orderDate.get('minutes') + orderDate.get('hours') * 60;
    const restaurantOpeningTime = this.getTimeInMinutes(starttime);
    return (
      now.get('date') === orderDate.get('date') &&
      now.get('month') === orderDate.get('month') &&
      (orderDateInMinutes >= closingTimeMinutes ||
        currentTimeRunning >= closingTimeMinutes ||
        (strictChecking && currentTimeRunning < restaurantOpeningTime))
    );
  }

  getReqestParams(params) {
    params = params || {};
    const deliveryDetails = get(
      this.props,
      'dashboardData.deliveryDetails',
      {}
    );
    const cartSplit = getCartPriceDetails(this.props);
    const cartContents = GetCartItems(this.props.orderItems);
    const isDelivery = Number(this.props.dashboardData.modeOfOrder) === 2; // order mode is delivery
    const orderId = get(
      this,
      'props.dashboardData.orderIdDetails.order_id',
      ''
    );
    const parseString = data => data.toString().replace(/[\n\r]/g, '');
    const deliverAddress = parseString(
      get(deliveryDetails, 'deliveryAddress', '')
    );
    const { orderDate, orderTime } = this.props.dashboardData;
    const requestParams = Object.assign(
      {},
      {
        payable_amount: cartSplit.grandTotal,
        rounding_amount: cartSplit.roundingAmount,
        dataname: this.props.dashboardData.dataName,
        order_id: orderId,
        tip_type: cartSplit.tip.type,
        tip_amount: parsePrice(cartSplit.tip.price, true),
        lavu_pay_type: get(this.props, 'checkoutData.discount.lavuPayType', ''),
        lavu_card_number: get(
          this.props,
          'checkoutData.discount.cardNumber',
          ''
        ),
        lavu_add_points: get(
          this.props,
          'checkoutData.discount.lavuAddPoints',
          0
        ),
        lavu_pay_amount: get(
          this.props,
          'checkoutData.discount.discount_value',
          0
        ),
        discount_id: get(this.props, 'checkoutData.discount.discount_id', ''),
        phone_number: this.state.phonenumber,
        email_id: this.state.email,
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        delivery_instructions: this.state.instructions,
        customer_address: isDelivery ? deliverAddress : '', // if order type delivery take delivery address
        delivery_fee: isDelivery ? cartSplit.deliveryFee : 0,
        order_type: GetOrderType(this.props.dashboardData.modeOfOrder),
        closed_date: moment().format('YYYY-MM-DD HH:mm:ss'),
        dining_date: moment().format('YYYY-MM-DD'),
        dining_time: isDelivery
          ? convertTime(this.props.dashboardData.locationDetails.deliveryTime) +
            ':00'
          : orderTime
            ? convertTime(orderTime) + ':00'
            : moment().format('HH:mm'),
        location_id: get(
          this.props,
          'dashboardData.merchantDetails.locationid'
        ),
        user_id: get(this.props, 'loginUserDetails.id', 0),
        cart_contents: cartContents,
        postalCode: isDelivery
          ? get(deliveryDetails, 'source.addressDetails.postalCode', '')
          : '',
        city: isDelivery
          ? get(deliveryDetails, 'source.addressDetails.city', '')
          : '',
        state: isDelivery
          ? get(deliveryDetails, 'source.addressDetails.state', '')
          : '',
        country: isDelivery
          ? get(deliveryDetails, 'source.addressDetails.country', '')
          : '',
        streetAddress: isDelivery
          ? get(deliveryDetails, 'source.streetAddress', '')
          : '',
      },
      params
    );
    if (!isDelivery && orderDate !== 'now' && orderDate !== '') {
      requestParams['dining_date'] = moment(orderDate, 'x').format(
        'YYYY-MM-DD'
      );
      requestParams['dining_time'] = convertTime(orderTime) + ':00';
    }

    return requestParams;
  }
  scrollToElement(element) {
    var topPos = element.getBoundingClientRect().top + window.scrollY;
    window.scroll(0, parseInt(topPos) - 100);
  }

  isValidateFormSubmit() {
    let validBoolean = false;
    let firstNameError = false;
    let lastNameError = false;
    let emailError = false;
    let phoneNoError = false;
    const deliveryAddress = get(
      this.props,
      'dashboardData.deliveryDetails.deliveryAddress',
      false
    );
    const orderType = GetOrderType(this.props.dashboardData.modeOfOrder);
    const isDelivery = Number(this.props.dashboardData.modeOfOrder) === 2;
    const { orderDate, orderTime } = this.props.dashboardData;
    if (
      !Required(this.state.firstName) &&
      !Required(this.state.lastName) &&
      !Required(this.state.email) &&
      !Required(this.state.phonenumber)
    ) {
      this.setState({
        firstNameError: true,
        lastNameError: true,
        emailError: true,
        phoneNoError: true,
      });
      this.scrollToElement(this.refs.row1);
      this.refs.firstName.focus();
      return false;
    }
    if (Required(this.state.firstName) && checkNumber(this.state.firstName)) {
      this.setState({ firstNameError: true });
      validBoolean = true;
      firstNameError = true;
    }
    if (!Required(this.state.firstName)) {
      this.setState({
        firstNameError: true,
      });
      validBoolean = true;
      firstNameError = true;
    }
    if (Required(this.state.lastName) && checkNumber(this.state.lastName)) {
      this.refs.lastName.focus();
      validBoolean = true;
      lastNameError = true;
    }
    if (!Required(this.state.lastName)) {
      this.setState({
        lastNameError: true,
      });
      validBoolean = true;
      lastNameError = true;
    }
    if (!Required(this.state.phonenumber)) {
      this.setState({
        phoneNoError: true,
      });
      validBoolean = true;
      phoneNoError = true;
    }
    if (!Mobile(this.state.phonenumber)) {
      this.setState({
        phoneNoError: true,
      });
      validBoolean = true;
      phoneNoError = true;
    }
    if (!Required(this.state.email)) {
      this.setState({
        emailError: true,
      });
      emailError = true;
      validBoolean = true;
    }
    if (!Email(this.state.email)) {
      this.setState({
        emailError: true,
      });
      emailError = true;
      validBoolean = true;
    }
    if (!this.validateTip() && this.props.restaurantDetails.isTipEnabled) {
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'notAValidTip',
          defaultMessage: defaultMsg.notAValidTip,
        })
      );
      validBoolean = true;
    }
    if (isDelivery && deliveryAddress === false) {
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'pleaseAddDeliveryAddress',
          defaultMessage: defaultMsg.pleaseAddDeliveryAddress,
        })
      );
      validBoolean = true;
    } else if (
      orderDate !== 'now' &&
      orderDate !== '' &&
      !this.props.dashboardData.orderDate
    ) {
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'pleaseSelect',
          defaultMessage: defaultMsg.pleaseSelect,
        }) +
          ' ' +
          orderType +
          ' ' +
          this.props.intl.formatMessage({
            id: 'date',
            defaultMessage: defaultMsg.date,
          })
      );
      validBoolean = true;
    }
    if (orderDate !== 'now' && orderDate !== '' && !orderTime) {
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'pleaseSelect',
          defaultMessage: defaultMsg.pleaseSelect,
        }) +
          ' ' +
          orderType +
          ' ' +
          this.props.intl.formatMessage({
            id: 'time',
            defaultMessage: defaultMsg.time,
          })
      );
      validBoolean = true;
    }
    if (validBoolean === true) {
      if (firstNameError === true) {
        this.scrollToElement(this.refs.row1);
        this.refs.firstName.focus();
      } else if (lastNameError === true) {
        this.scrollToElement(this.refs.row1);
        this.refs.lastName.focus();
      } else if (phoneNoError === true) {
        this.scrollToElement(this.refs.row2);
        this.refs.phoneNumber.focus();
      } else if (emailError === true) {
        this.scrollToElement(this.refs.row2);
        this.refs.email.focus();
      }
      return false;
    } else {
      return true;
    }
  }

  handlePaypalCheckout(instance, e) {
    e.preventDefault();
    if (this.isValidateFormSubmit()) {
      let redirect = false;
      let itemName;
      this.props.dashboardData.orderItemsList.map((item, i) => {
        if (item.availability === 'Not Available') {
          itemName = item.name;
          redirect = false;
          return [itemName, redirect];
        } else {
          redirect = true;
          return redirect;
        }
      });

      if (redirect) {
        this.setState({
          checkingOut: true,
        });
        instance.requestPaymentMethod((requestPaymentMethodErr, payload) => {
          if (requestPaymentMethodErr) {
            this.setState({ checkingOut: false, paypalPaymentError: true });
            // this.refs.checkout_container.error(requestPaymentMethodErr);
            return;
          } else {
            let languageid = localStorage.getItem('language')
              ? localStorage.getItem('language')
              : '1';
            let self = this;
            const requestParams = this.getReqestParams({
              payment_method_nonce: payload.nonce,
              languageid: languageid,
            });
            // this.setState({ checkingOut: true });
            axios
              .post(
                ORDER_PAYPAL_WALLET + 'tokenId/' + this.props.tokenId,
                requestParams,
                requestHeaders(this.props.jwt)
              )
              .then(function(response) {
                self.setState({ checkingOut: false });
                const { status = '', msg = '' } = response.data.DataResponse;
                if (status.toLowerCase() === 's') {
                  instance.teardown(function(teardownErr) {
                    if (!teardownErr) {
                      let button = document.querySelector('#submit-button');
                      if (button) button.remove();
                    }
                  });

                  self.setState({ placingOrder: true }, function() {
                    self.props.dispatch(resetPostCheckout());
                    this.orderSuccessMessage(
                      response.data.DataResponse,
                      requestParams,
                      function() {
                        setTimeout(function() {
                          window.location.replace('/' + self.props.rname);
                        }, 200);
                      }
                    );
                  });
                  self.props.dispatch(emptyCart());
                } else {
                  if (response.data.DataResponse.outofstock) {
                    self.setState({
                      showOutOfStock: response.data.DataResponse.outofstock,
                    });
                  } else if (
                    typeof response.data.DataResponse.msg === 'object'
                  ) {
                    msg.forEach((error, key) => {
                      self.refs.checkout_container.error(error);
                    });
                  } else {
                    self.refs.checkout_container.error(msg);
                  }
                }
              })
              .catch(e => self.setState({ checkingOut: false }));
          }
        });
      } else {
        this.refs.checkout_container.error(
          itemName +
            this.props.intl.formatMessage({
              id: 'isNotAvailable',
              defaultMessage: defaultMsg.isNotAvailable,
            })
        );
      }
    }
  }

  scrollBottom = () => {
    if (this.state.scrollBottom) {
      window.scrollTo(0, document.body.scrollHeight);
      this.setState({ scrollBottom: false });
    }
  };

  handleChange() {
    ReactDOM.findDOMNode(this.refs.address).removeAttribute('readonly');
    this.setState({
      check: true,
    });
  }

  phoneNumberOnchange(event) {
    let cookieData = cookieValue('token');
    if (cookieData == null) {
      this.props.dispatch(updateGuestUser({ mobile: event.target.value }));
    }
    this.setState({ phonenumber: event.target.value, phoneNoError: false });
  }

  emailOnchange(event) {
    let cookieData = cookieValue('token');
    if (cookieData == null) {
      this.props.dispatch(updateGuestUser({ email: event.target.value }));
    }
    this.setState({ email: event.target.value, emailError: false });
  }

  firstNameOnchange(event) {
    let cookieData = cookieValue('token');
    if (testRegex('^[a-zA-Z0-9_ ]*$', event.target.value)) {
      if (cookieData == null) {
        this.props.dispatch(
          updateGuestUser({ first_name: event.target.value })
        );
      }
      this.setState({ firstName: event.target.value, firstNameError: false });
    }
  }

  lastNameOnchange(event) {
    let cookieData = cookieValue('token');
    if (testRegex('^[a-zA-Z0-9_ ]*$', event.target.value)) {
      if (cookieData == null) {
        this.props.dispatch(updateGuestUser({ last_name: event.target.value }));
      }
      this.setState({ lastName: event.target.value, lastNameError: false });
    }
  }

  instructionsOnchange(event) {
    if (testRegex(/^[a-zA-Z0-9_\s]*$/, event.target.value)) {
      this.setState({
        instructions: event.target.value,
        instructionsError: false,
      });
    }
  }

  handleCheckAdr() {
    fetch(DELIVERY_ADDRESS_URL + 'tokenId/' + this.props.tokenId, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + btoa(this.props.jwt),
      },
      body: JSON.stringify({
        lavu_togo_name: this.props.rname,
        streetAddress: this.props.dashboardData.locationDetails
          .selectedLocationAddress,
      }),
    })
      .catch(error => {
        API_ERROR(error);
      })
      .then(res => res.json())
      .then(data => {
        if (data.DataResponse.sourceaddress.length > 0) {
          this.refs.checkout_container.success(
            this.props.intl.formatMessage({
              id: 'deliveryAvailable',
              defaultMessage: defaultMsg.deliveryAvailable,
            })
          );
          this.props.validateDeliveryAddress(true);
          this.setState({
            delAdrInvalid: false,
          });
        } else {
          this.refs.checkout_container.error(
            this.props.intl.formatMessage({
              id: 'deliveryNotAvailable',
              defaultMessage: defaultMsg.deliveryNotAvailable,
            })
          );
          this.setState({
            delAdrInvalid: true,
          });
          this.props.validateDeliveryAddress(false);
        }
      })
      .catch(error => {
        API_ERROR(error);
      });
  }

  handleChangeAdr(e) {
    let obj = {
      selectedLocationAddress: e.target.value,
    };
    this.props.dispatch(locationDetails(obj));
  }

  handlePaymentMode(mode, sroll = true) {
    if (!this.state.delAdrInvalid) {
      this.setState({
        paymentMode: mode,
        scrollBottom: sroll,
        loading: mode === 'paypal' && this.isOrderTimeValid() ? mode : false,
      });
      this.props.setPayModeState(mode);
      this.props.dispatch(setPaymentModeDashboard(mode));

      if (mode === 'meal_plan') {
        this.handleAddTip(tipType.notip);
      }
    } else {
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'pleaseSelectDeliveryAddress',
          defaultMessage: defaultMsg.pleaseSelectDeliveryAddress,
        })
      );
    }
  }

  handleAddTip(tip) {
    let tipAmount = 0;
    let tipPercent = 0;
    let tipType = '';
    const cartSplit = getCartPriceDetails(this.props, 'false');

    if (tip === 'notip') {
      tipAmount = 0.0;
      tipType = '';
    } else if (tip === 'custom') {
      this.setState({
        customTip: '',
      });
      tipAmount = 0;
      tipType = 'C';
    } else if (tip === '15') {
      tipType = 'P';
      tipPercent = 15;
    } else if (tip === '20') {
      tipType = 'P';
      tipPercent = 20;
    } else if (tip === '25') {
      tipType = 'P';
      tipPercent = 25;
    } else if (tip === '30') {
      tipType = 'P';
      tipPercent = 30;
    } else {
      tipType = 'C';
    }
    if (tipType === 'P') {
      tipAmount =
        parseFloat(parsePrice(cartSplit.grandTotal, true)) * (tipPercent / 100);
    }
    this.props.updateTip(tipAmount, tipType, tipPercent);
    this.setState({
      addTip: tip,
    });
  }

  changeDiningOption(mode) {
    const changeMode = Number(mode);
    if (Number(this.props.dashboardData.modeOfOrder) !== changeMode) {
      this.props.changeDiningOption(changeMode);
    }
  }

  checkoutWithBridgepay(e) {
    e.preventDefault();
    if (this.state.email === '' || this.state.phonenumber === '') {
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'pleaseEnterTelephoneEmail',
          defaultMessage: defaultMsg.pleaseEnterTelephoneEmail,
        })
      );
    } else {
      let totalPrice = 0;
      this.props.orderItems.map(item => {
        totalPrice = totalPrice + parsePrice(item.price, true);
        return totalPrice;
      });

      let redirect = false;
      let itemName;
      this.props.dashboardData.orderItemsList.map((item, i) => {
        if (item.availability === 'Not Available') {
          itemName = item.name;
          redirect = false;
          return [itemName, redirect];
        } else {
          redirect = true;
          return redirect;
        }
      });
      if (redirect) {
        window.location.replace(
          BRIDGEPAY_URL +
            'amount=' +
            totalPrice +
            '&order_id=' +
            this.props.dashboardData.orderIdDetails.order_id
        );
      } else {
        this.refs.checkout_container.error(
          itemName +
            this.props.intl.formatMessage({
              id: 'isNotAvailable',
              defaultMessage: defaultMsg.isNotAvailable,
            })
        );
      }
    }
  }

  checkoutWithCod(e) {
    e.preventDefault();
    if (this.isValidateFormSubmit()) {
      let redirect = false;
      let itemName;
      this.props.dashboardData.orderItemsList.map((item, i) => {
        if (item.availability === 'Not Available') {
          itemName = item.name;
          redirect = false;
          return [itemName, redirect];
        } else {
          redirect = true;
          return redirect;
        }
      });
      if (redirect) {
        let self = this;
        const requestParams = this.getReqestParams();
        this.setState({ checkingOut: true });
        this.props.payCOD(requestParams, function callBackAfterPayment(
          response
        ) {
          self.setState({ checkingOut: false });
          if (response.response.data.DataResponse.status === 'F') {
            if (response.response.data.DataResponse.outofstock) {
              self.setState({
                showOutOfStock: response.response.data.DataResponse.outofstock,
              });
            } else {
              onServerError(response.response.data.DataResponse.msg);
            }
          } else if (response.response.data.DataResponse.status) {
            let cookieData = cookieValue('token');
            if (cookieData == null) {
              self.props.dispatch(removeGuestUser());
            }
            self.setState({ placingOrder: true }, function() {
              self.props.dispatch(resetPostCheckout());
              this.orderSuccessMessage(
                response.response.data.DataResponse,
                requestParams,
                function() {
                  setTimeout(function() {
                    window.location.replace('/' + self.props.rname);
                  }, 200);
                }
              );
            });
            self.props.dispatch(emptyCart());
          } else {
            self.refs.checkout_container.error(
              response.response.data.DataResponse.result
            );
          }
        });
      } else {
        this.refs.checkout_container.error(
          itemName +
            this.props.intl.formatMessage({
              id: 'isNotAvailable',
              defaultMessage: defaultMsg.isNotAvailable,
            })
        );
      }
    }
  }

  calcTotalMealPlanAvailable = () =>
    get(this.props, 'loginUserDetails.mealplan.stipend_balance', 0) +
    get(this.props, 'loginUserDetails.mealplan.card_balance', 0);

  calcTotalOwed = () => {
    const cartSplit = getCartPriceDetails(this.props);

    // Cart items total w/ tax and tip
    const cartTotal = cartSplit.grandTotal;

    // Discount
    const { discount = {} } = this.props.checkoutData;
    let discountValue = 0;
    if (discount.discount_value) {
      discountValue = Number(discount.discount_value);
    }

    // Formatting
    const { merchantDetails = {} } = this.props.dashboardData;
    const decimalPoint = merchantDetails.disable_decimal
      ? Number(merchantDetails.disable_decimal)
      : 0;

    return (cartTotal - discountValue).toFixed(decimalPoint);
  };

  hasSufficientMealPlanFunds = () => {
    const totalOwed = +this.calcTotalOwed();
    const mealPlanTotalAvailable = this.calcTotalMealPlanAvailable();

    return totalOwed <= mealPlanTotalAvailable;
  };

  requiredMealPlanFunds = (formatted = false) => {
    const totalOwed = +this.calcTotalOwed();
    const mealPlanTotalAvailable = this.calcTotalMealPlanAvailable();

    return parsePrice(totalOwed - mealPlanTotalAvailable, formatted);
  };

  addMealPlanFunds = () => {
    window.location.replace(
      `/${this.props.rname}/${MEAL_PLAN}/${this.requiredMealPlanFunds(true)}`
    );
  };

  checkoutWithMealPlan(e) {
    //call tom's api call to update values.
    e.preventDefault();
    if (this.isValidateFormSubmit()) {
      let redirect = false;
      let itemName;

      this.props.dashboardData.orderItemsList.map((item, i) => {
        if (item.availability === 'Not Available') {
          itemName = item.name;
          redirect = false;
          return [itemName, redirect];
        } else {
          redirect = true;
          return redirect;
        }
      });

      if (redirect) {
        if (!this.hasSufficientMealPlanFunds()) {
          return;
        }
        this.setState({ checkingOut: true });
        const requestParams = this.getReqestParams();
        this.props.payMealPlan(requestParams, response => {
          if (
            response === null ||
            response.data.DataResponse.status === 'F' ||
            response.data.DataResponse.status === 'F1' ||
            response.data.DataResponse.status === 'F2'
          ) {
            if (response.data.DataResponse.outofstock) {
              this.setState({
                showOutOfStock: response.data.DataResponse.outofstock,
              });
            } else {
              onServerError(response.data.DataResponse.msg);
            }
          } else if (response.data.DataResponse.status) {
            this.setState({
              placingOrder: true,
            });
            const callbackAfterMealPlan = () => {
              return this.props.dispatch(resetPostCheckout()).then(res => {
                window.location.replace('/' + this.props.rname);
              });
            };
            this.props.dispatch(emptyCart());
            this.props.dispatch(
              updateMealPlan(response.data.DataResponse.mealplan)
            );
            this.orderSuccessMessage(
              response.data.DataResponse,
              requestParams,
              callbackAfterMealPlan
            );
          } else {
            this.refs.checkout_container.error(
              response.data.DataResponse.result
            );
          }
          this.setState({ checkingOut: false });
        });
      }
    }
  }

  customTipChange(event) {
    const givenTip = event.target.value;
    const { decimalSeparator, decimalPoints } = this.props.restaurantDetails;
    let tipPattern = `^[0-9]*\\${decimalSeparator}?[0-9]{0,${decimalPoints}}$`;
    if (!decimalSeparator) {
      tipPattern = `^[0-9]*[0-9]{0,${decimalPoints}}$`;
    }
    const tip = new RegExp(tipPattern, 'gi');
    if (
      this.state.addTip === 'custom' &&
      (tip.test(givenTip) || givenTip.length === 0)
    ) {
      this.setState({ customTip: givenTip });
      this.props.updateTip(parsePrice(givenTip, true), 'C', 0);
    }
  }

  handleGiftCard(e) {
    e.preventDefault();
    let languageid = localStorage.getItem('language')
      ? localStorage.getItem('language')
      : '1';
    let cardNumber = ReactDOM.findDOMNode(this.refs.giftCard).value;
    if (cardNumber !== '') {
      fetch(GIFT_CARD_URL + 'tokenId/' + this.props.tokenId, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + btoa(this.props.jwt),
        },
        body: JSON.stringify({
          dataname: this.props.dashboardData.dataName,
          lavuCard: cardNumber,
          orderId: this.props.dashboardData.orderIdDetails.order_id,
          languageid: languageid,
        }),
      })
        .catch(error => {
          API_ERROR(error);
        })
        .then(res => res.json())
        .then(data => {
          if (data.DataResponse && data.DataResponse.error) {
            this.refs.checkout_container.error(data.DataResponse.error);
          } else if (data.DataResponse === null) {
            this.refs.checkout_container.error(
              this.props.intl.formatMessage({
                id: 'responseNull',
                defaultMessage: defaultMsg.responseNull,
              })
            );
          } else {
            let obj = {
              cardNumber: ReactDOM.findDOMNode(this.refs.giftCard).value,
              balance: data.DataResponse.lavu_gift_card_balance,
            };
            this.setState({
              giftCardData: obj,
              giftCardModal: true,
            });
          }
        })
        .catch(error => {
          API_ERROR(error);
        });
    } else {
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'pleaseEnterGiftCardNumber',
          defaultMessage: defaultMsg.pleaseEnterGiftCardNumber,
        })
      );
    }

    return false;
  }

  getDiscountDetails() {
    if (this.props.checkout && this.props.checkout.discount) {
      return this.props.checkout.discount;
    }

    if (this.props.checkoutData && this.props.checkoutData.discount) {
      return this.props.checkoutData.discount;
    }

    return false;
  }

  isDiscountSelected() {
    if (this.props.checkout && this.props.checkout.discount) {
      return true;
    }

    if (this.props.checkoutData && this.props.checkoutData.discount) {
      return true;
    }

    return false;
  }
  handleLoyaltyCardChange() {
    let cardNumber = ReactDOM.findDOMNode(this.refs.cardNumber).value;
    if (cardNumber.length > 11) {
      ReactDOM.findDOMNode(this.refs.cardNumber).value = cardNumber.substring(
        0,
        11
      );
    }
  }

  handleLoyaltyPoint(updatedAwardPoint, e) {
    if (e) {
      e.preventDefault();
    }
    let cardNumber = ReactDOM.findDOMNode(this.refs.cardNumber).value;
    let languageid = localStorage.getItem('language')
      ? localStorage.getItem('language')
      : '1';
    if (cardNumber !== '') {
      this.setState({ loading: loadingStates['loyality'] });
      fetch(LOYALTY_POINTS_URL + 'tokenId/' + this.props.tokenId, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + btoa(this.props.jwt),
        },
        body: JSON.stringify({
          dataname: this.props.dashboardData.dataName,
          lavuCard: cardNumber,
          orderId: this.props.dashboardData.orderIdDetails.order_id,
          cart_contents: GetCartItems(this.props.orderItems),
          discount_id: 0,
          languageid: languageid,
        }),
      })
        .catch(error => {
          this.setState({ loading: false });
          API_ERROR(error);
        })
        .then(res => res.json())
        .then(data => {
          this.setState({ loading: false });
          if (data.DataResponse.error) {
            this.refs.checkout_container.error(data.DataResponse.error);
          } else {
            let obj = {
              number: ReactDOM.findDOMNode(this.refs.cardNumber).value,
              details: data.DataResponse,
            };
            this.setState({
              loyaltyCardData: obj,
              loyaltyCardModal: true,
            });
            this.props.dispatch(setLoyalityCardData(obj));
            if (updatedAwardPoint === true) {
              this.handleAwardPoint(updatedAwardPoint);
            }
          }
        })
        .catch(error => {
          this.setState({ loading: false });
          API_ERROR(error);
        });
    } else {
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'pleaseEnterLoyaltyCardNumber',
          defaultMessage: defaultMsg.pleaseEnterLoyaltyCardNumber,
        })
      );
    }
  }

  closeLoyaltyCardModal() {
    this.setState({
      loyaltyCardModal: false,
      showLoyaltyPopover: false,
    });
  }

  closeGiftCardModal() {
    this.setState({
      giftCardModal: false,
    });
  }

  isDiscountAvailable() {
    const discounttypes = get(
      this.state,
      'loyaltyCardData.details.discounttypes',
      []
    );
    return discounttypes.length > 0;
  }

  toggleLoyaltyPopover() {
    if (this.isDiscountAvailable()) {
      this.setState({
        showLoyaltyPopover: !this.state.showLoyaltyPopover,
      });
    } else {
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'noDiscountsAvailable',
          defaultMessage: defaultMsg.noDiscountsAvailable,
        })
      );
    }
  }

  refreshTaxDetails(taxdetails, doNotEdit) {
    if (taxdetails) {
      this.props.dispatch(refreshTaxDetails(taxdetails, doNotEdit));
    }
  }

  storeLoyaltyData(data, nextProps) {
    let languageid = localStorage.getItem('language')
      ? localStorage.getItem('language')
      : '1';
    let cardNumber = data.cardNumber
      ? data.cardNumber
      : this.state.loyaltyCardData.number;

    if (cardNumber !== '') {
      this.setState({
        loading: loadingStates['loyality'],
        loyaltyDiscountId: data.discount_id,
      });
      fetch(LOYALTY_POINTS_URL + 'tokenId/' + this.props.tokenId, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + btoa(this.props.jwt),
        },
        body: JSON.stringify({
          dataname: this.props.dashboardData.dataName,
          lavuCard: cardNumber,
          orderId: this.props.dashboardData.orderIdDetails.order_id,
          cart_contents: GetCartItems(
            nextProps ? nextProps.orderItems : this.props.orderItems
          ),
          discount_id: data.discount_id,
          languageid: languageid,
        }),
      })
        .catch(error => {
          this.setState({ loading: false });
          API_ERROR(error);
        })
        .then(res => res.json())
        .then(response => {
          const status = get(response, 'DataResponse.status', false);
          if (status) {
            let discountDetails = data;
            this.setState({
              loading: false,
              showLoyaltyPopover: false,
            });
            discountDetails['cardNumber'] = cardNumber;
            discountDetails['lavuAddPoints'] = 0;
            discountDetails['lavuPayType'] = 'LP';
            discountDetails['lavuDisplayType'] = 'discount';
            discountDetails['title'] = get(
              response,
              'DataResponse.discounttypes.title',
              'Applied'
            );
            discountDetails['computeInCartTotal'] = true;
            discountDetails['discount_value'] = get(
              response,
              'DataResponse.discounttypes.discount_value',
              0
            );
            this.props.loyaltyDiscount(discountDetails);
            this.refreshTaxDetails(response.DataResponse.taxdetails, true);
            this.closeLoyaltyCardModal();
          }
        });
    }
  }

  handleAwardPoint(updatedAwardPoint, e) {
    if (e) {
      e.preventDefault();
    }
    if (this.state.loyaltyCardData.details.awardpoints === 0) {
      this.props.loyaltyDiscount({});
      this.refs.checkout_container.error(
        this.props.intl.formatMessage({
          id: 'noAwardPointsAvailable',
          defaultMessage: defaultMsg.noAwardPointsAvailable,
        })
      );
    } else {
      this.setState({
        loyaltyCardModal: false,
        showLoyaltyPopover: false,
        awardPointModal: !updatedAwardPoint,
      });
      let obj = {};
      obj['cardNumber'] = this.state.loyaltyCardData.number;
      obj['discount_value'] = this.state.loyaltyCardData.details.awardpoints;
      obj['lavuAddPoints'] = 1;
      obj['lavuPayType'] = 'LP';
      obj['discount_id'] = '';
      obj['lavuDisplayType'] = 'awardpoints';
      obj['title'] =
        this.props.intl.formatMessage({
          id: 'appliedAwardPoints',
          defaultMessage: defaultMsg.appliedAwardPoints,
        }) + obj.discount_value;
      obj['computeInCartTotal'] = false;
      this.props.loyaltyDiscount(obj);
      this.props.dispatch(restoreTaxDetails());
    }
  }

  handleGiftCardDiscount() {
    this.setState({
      giftCardModal: false,
    });
    let obj = {};
    obj['cardNumber'] = this.state.giftCardData.cardNumber;
    obj['discount_value'] = this.state.giftCardData.balance;
    obj['lavuAddPoints'] = '';
    obj['lavuPayType'] = 'GC';
    obj['discount_id'] = '';
    obj['lavuDisplayType'] = 'giftCard';
    this.props.loyaltyDiscount(obj);
    this.closeLoyaltyCardModal();
  }

  renderMealPlanButton() {
    return this.state.enableMealPlanButton === true ? (
      <button
        className={`btn btn-success diningButton marginBtwButtons col-md-2 ${
          this.state.paymentMode === 'meal_plan' ? 'active' : ''
        }`}
        onClick={this.handlePaymentMode.bind(this, 'meal_plan')}
        disabled={!this.isOrderTimeValid()}
        type="button"
      >
        <span>
          <FormattedMessage
            id="mealPlan"
            defaultMessage={defaultMsg.mealPlan}
          />
        </span>
      </button>
    ) : null;
  }

  isOrderTimeValid = () => {
    const { orderDetails = {} } = this.props;
    return orderDetails.isOrderTimeValid;
  };
  validateOrder = () => {
    if (!this.isOrderItemsAvailableNow()) {
      this.refs.checkout_container.error(defaultMsg.itemsSoldOut);
      return false;
    }
    return true;
  };
  isOrderItemsAvailableNow = () => {
    const { orderDetails, rtd } = this.props;
    const isRTDAvailableNow = v => {
      return v === undefined || isAvailableNow(v);
    };
    const isSelectedModifiersAvailable = (
      modifiers,
      type = MODIFIER_FORCED
    ) => {
      return modifiers.filter(m => m.selected).every(modifier => {
        return modifier.option
          .filter(option => option.selected)
          .every(option => {
            const unavailableUntil =
              rtd[type === MODIFIER_FORCED ? 'forced_modifier' : 'modifier'][
                option.id
              ];
            if (!isRTDAvailableNow(unavailableUntil)) {
              return false;
            }
            if (option.doption && option.doption.length) {
              return isSelectedModifiersAvailable(
                option.doption,
                MODIFIER_FORCED
              );
            }
            return true;
          });
      });
    };
    if (orderDetails.items && orderDetails.items.length) {
      return orderDetails.items.every(item => {
        const unavailableUntil = rtd['menu_item'][item.id];
        if (!isRTDAvailableNow(unavailableUntil)) {
          return false;
        }
        if (
          item.forced &&
          item.forced.length &&
          !isSelectedModifiersAvailable(item.forced, MODIFIER_FORCED)
        ) {
          return false;
        }
        if (
          item.optional &&
          item.optional.length &&
          !isSelectedModifiersAvailable(item.optional, MODIFIER_OPTIONAL)
        ) {
          return false;
        }
        return true;
      });
    }
    return true;
  };

  renderPaymentSection = () => {
    const {
      paymentMode,
      paypalPaymentError,
      currentTimeCompare,
      isNowAvialable,
      loading,
      checkingOut,
      paymentReady,
    } = this.state;

    switch (paymentMode) {
      case 'Credit Card':
        return (
          <div className="col-lg-9 col-md-9 col-sm-8 col-xs-12">
            <div className="formField">
              <button
                className="btn btn-success diningButton active alignCenter"
                onClick={e => {
                  e.preventDefault();
                  if (this.validateOrder()) {
                    this.checkoutWithBridgepay(e);
                  }
                }}
                disabled={
                  !this.isOrderTimeValid() ||
                  this.state.checkingOut ||
                  this.state.loading !== false
                }
              >
                <FormattedMessage
                  id="checkoutBridgepay"
                  defaultMessage={defaultMsg.checkoutBridgepay}
                />
              </button>
            </div>
          </div>
        );
      case 'paypal':
        const btnCls = `btn btn-${
          paypalPaymentError ? 'danger' : 'success diningButton'
        } active `;
        return (
          <div>
            <div
              className="col-lg-9 col-md-9 col-sm-8 col-xs-12 formField"
              ref={this.setupPaymentDetails}
              id="dropin-container"
            />
            <div className="col-lg-9 col-md-9 col-sm-8 col-xs-12 checkoutPadding">
              {currentTimeCompare &&
              isNowAvialable &&
              loading === loadingStates['paypal'] ? (
                <button className={btnCls} disabled id="submit-button">
                  <FormattedMessage
                    id="loadingText"
                    defaultMessage={defaultMsg.loadingText}
                  />
                  <MdLoaderWhite size={15} />
                </button>
              ) : checkingOut === true ? (
                <button className={btnCls} disabled id="submit-button">
                  <FormattedMessage
                    id="checkingOutPaypal"
                    defaultMessage={defaultMsg.checkingOutPaypal}
                  />
                  <MdLoaderWhite size={15} />
                </button>
              ) : (
                <button
                  id="submit-button"
                  disabled={
                    !this.isOrderTimeValid() ||
                    checkingOut ||
                    !paymentReady ||
                    loading !== false ||
                    (this.isDeliveryModeSelected() &&
                      !this.isRestaurantAvailableForDelivery())
                  }
                  className={btnCls}
                  ref={payWithPayPal => {
                    this.payWithPayPal = payWithPayPal;
                  }}
                >
                  <span>
                    <FormattedMessage
                      id="placeYourOrder"
                      defaultMessage={defaultMsg.placeYourOrder}
                    />
                  </span>
                </button>
              )}
              {paypalPaymentError && (
                <a
                  href=""
                  onClick={e => {
                    e.preventDefault();
                    this.setupPaymentDetails();
                  }}
                  className="pl-1"
                >
                  Error. Try again?
                </a>
              )}
            </div>
          </div>
        );
      case 'cod':
        const modeOfOrder = Number(this.props.dashboardData.modeOfOrder);
        return (
          <div className="col-lg-9 col-md-9 col-sm-8 col-xs-12">
            <div className="formField">
              {checkingOut === true ? (
                <button
                  className="btn btn-success diningButton active"
                  disabled
                >
                  {modeOfOrder <= 3 && modeOfOrder >= 1 ? (
                    <FormattedMessage
                      id="placeYourOrder"
                      defaultMessage={defaultMsg.placeYourOrder}
                    />
                  ) : null}
                  <MdLoaderWhite size={15} />
                </button>
              ) : (
                <button
                  className="btn btn-success diningButton active"
                  onClick={e => {
                    e.preventDefault();
                    if (this.validateOrder()) {
                      this.checkoutWithCod(e);
                    }
                  }}
                  disabled={
                    !this.isOrderTimeValid() ||
                    checkingOut ||
                    loading !== false ||
                    (this.isDeliveryModeSelected() &&
                      !this.isRestaurantAvailableForDelivery())
                  }
                  ref={payWithCash => {
                    this.payWithCash = payWithCash;
                  }}
                >
                  {modeOfOrder <= 3 && modeOfOrder >= 1 ? (
                    <FormattedMessage
                      id="placeYourOrder"
                      defaultMessage={defaultMsg.placeYourOrder}
                    />
                  ) : null}
                </button>
              )}
            </div>
          </div>
        );
      case 'meal_plan':
        return (
          <div className="col-lg-9 col-md-9 col-sm-8 col-xs-12 formField">
            <h5 className="secondaryFont">
              <span>
                <FormattedMessage
                  id="mealPlanInformation"
                  defaultMessage={defaultMsg.mealPlanInformation}
                />
              </span>
            </h5>
            <div className="account_information row">
              <div className="stipendBalance col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <span className="primaryFont">
                  <FormattedMessage
                    id="stipendBalance"
                    defaultMessage={defaultMsg.stipendBalance}
                  />
                </span>
                <input
                  type="text"
                  value={parsePrice(
                    get(
                      this.props,
                      'loginUserDetails.mealplan.stipend_balance',
                      0
                    )
                  )}
                  className="form-control"
                  disabled
                />
              </div>
              <div className="cashBalance col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <span className="primaryFont">
                  <FormattedMessage
                    id="cashBalance"
                    defaultMessage={defaultMsg.cashBalance}
                  />
                </span>
                <input
                  type="text"
                  value={parsePrice(
                    get(this.props, 'loginUserDetails.mealplan.card_balance', 0)
                  )}
                  className="form-control"
                  disabled
                />
              </div>
              <div className="totalBalance col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <span className="primaryFont">
                  <FormattedMessage
                    id="totalBalance"
                    defaultMessage={defaultMsg.totalBalance}
                  />
                </span>
                <input
                  type="text"
                  value={parsePrice(this.calcTotalMealPlanAvailable())}
                  className="form-control"
                  disabled
                />
              </div>
            </div>
            <div className="formField">
              {checkingOut === true ? (
                <button
                  className="btn btn-success diningButton active alignCenter"
                  disabled
                >
                  <FormattedMessage
                    id="checkingOutMealPlan"
                    defaultMessage={defaultMsg.checkingOutMealPlan}
                  />
                </button>
              ) : (
                <div>
                  {!this.hasSufficientMealPlanFunds() ? (
                    <div className="alert alert-danger">
                      <div className="row">
                        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                          <strong>
                            <FormattedMessage
                              id="errorInsufficientFunds"
                              defaultMessage={defaultMsg.errorInsufficientFunds}
                            />
                          </strong>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                          <button
                            type="button"
                            className="btn btn-link btn-small pull-right"
                            onClick={this.addMealPlanFunds}
                          >
                            <FormattedMessage
                              id="addText"
                              defaultMessage={defaultMsg.addText}
                              values={{
                                suffix: this.requiredMealPlanFunds() + '?',
                              }}
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <button
                    className="btn btn-success diningButton active alignCenter"
                    onClick={e => {
                      if (this.validateOrder()) {
                        this.checkoutWithMealPlan(e);
                      }
                    }}
                    disabled={
                      !this.hasSufficientMealPlanFunds() ||
                      !this.isOrderTimeValid() ||
                      this.state.checkingOut ||
                      this.state.loading !== false
                    }
                  >
                    <FormattedMessage
                      id="checkoutMealPlan"
                      defaultMessage={defaultMsg.checkoutMealPlan}
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  displayOrderTime(orderTypeText, isMsgRequired) {

    return (
      <div>
        {Number(this.props.dashboardData.modeOfOrder) !== 2 ? (
          <div className="col-lg-9 col-md-9 col-sm-8 col-xs-12">
            <span className="primaryColor primaryFont">
              {this.state.restaurantClosed ? (
                <span className="label label-danger">
                  {isMsgRequired
                    ? this.props.intl.formatMessage({
                        id: 'restaurantNotAcceptingOrder',
                        defaultMessage: defaultMsg.restaurantNotAcceptingOrder,
                      })
                    : null}
                </span>
              ) : (
                <span>
                  <span className="label label-success">
                    {this.state.filteredDate
                      ? `${orderTypeText}, ${this.state.filteredDate} `
                      : null}
                  </span>
                  {this.state.istimeUpdated ? (
                    <div className="font-small-xs" style={{ color: '#e60000' }}>
                      ({`${orderTypeText}`} ,
                      <FormattedMessage
                        id="timeUpdatedFrom"
                        defaultMessage={defaultMsg.timeUpdatedFrom}
                      />
                      :<strike>{this.props.dashboardData.orderTime}</strike>)
                    </div>
                  ) : null}
                </span>
              )}
            </span>
          </div>
        ) : null}
      </div>
    );
  }

  isOnlyMealPlanEnabled = () => {
    return (
      this.props.isPrepayOnly &&
      this.props.isNotValidPaymentOptions &&
      this.state.enableMealPlanButton
    );
  };

  isMealPlanEnabled = () => {
    return this.props.isPrepayOnly && this.state.enableMealPlanButton;
  };

  isCardOptionEnabled = () => {
    return (
      this.props.isPrepayOnly &&
      !this.props.isNotValidPaymentOptions &&
      this.props.restaurantDetails.paypalSandboxToken &&
      this.props.restaurantDetails.isPayPalEnabled
    );
  };

  isMultiplePaymentOptionAvailable = () => {
    const isCardOptionEnabled = this.isCardOptionEnabled();
    const isMealPlanEnabled = this.isMealPlanEnabled();
    return (
      !this.state.updatingPayment &&
      ((this.props.isPaymentUponRecieptOnly &&
        this.props.isPrepayOnly &&
        (isMealPlanEnabled || isCardOptionEnabled)) ||
        (isCardOptionEnabled && isMealPlanEnabled))
    );
  };

  noPaymentOptionAvailable = () => {
    return (
      !this.state.updatingPayment &&
      (!this.props.isPaymentUponRecieptOnly && !this.props.isPrepayOnly)
    );
  };
  isDeliveryModeSelected = () => this.props.dashboardData.modeOfOrder === 2;
  isRestaurantAvailableForDelivery = () => {
    const { hoursOfOperation } = this.props.restaurantDetails;
    return isRestaurantAvailable(hoursOfOperation, moment());
  };

  render() {
    let orderTypeText = '';
    let discountDetails = this.getDiscountDetails();

    switch (this.props.dashboardData.modeOfOrder) {
      case 0: {
        orderTypeText = '';
        break;
      }
      case 1: {
        orderTypeText = this.props.intl.formatMessage({
          id: 'pickup',
          defaultMessage: defaultMsg.pickup,
        });
        break;
      }
      case 2: {
        orderTypeText = this.props.intl.formatMessage({
          id: 'delivery',
          defaultMessage: defaultMsg.delivery,
        });
        break;
      }
      case 3: {
        orderTypeText = this.props.intl.formatMessage({
          id: 'dineIn',
          defaultMessage: defaultMsg.dineIn,
        });
        break;
      }
      default: {
        orderTypeText = '';
        break;
      }
    }

    let popoverTop;

    if (this.state.loyaltyCardModal && this.isDiscountAvailable()) {
      let self = this;
      let title =
        this.state.loading === loadingStates['loyality']
          ? this.props.intl.formatMessage({
              id: 'calculatingDiscount',
              defaultMessage: defaultMsg.calculatingDiscount,
            })
          : this.props.intl.formatMessage({
              id: 'selectDiscount',
              defaultMessage: defaultMsg.selectDiscount,
            });

      popoverTop = (
        <Popover id="popover-positioned-scrolling-top" title={title}>
          <ul style={{ maxHeight: '100px', overflowY: 'auto', padding: '2px' }}>
            {this.state.loyaltyCardData.details.discounttypes.map(function(
              data
            ) {
              let checked = false;
              if (self.state.loyaltyDiscountId === data.discount_id) {
                checked = true;
              } else {
                checked = false;
              }

              if (!data.discount_id) {
                return null;
              }

              return (
                <li
                  style={{
                    listStyleType: 'none',
                    cursor: 'pointer',
                    borderBottom: '1px solid #eee',
                  }}
                  key={data.discount_id}
                >
                  <input
                    name="discount"
                    type="radio"
                    checked={checked}
                    onClick={() => self.storeLoyaltyData(data)}
                  />
                  &nbsp;
                  {data.title}
                </li>
              );
            })}
          </ul>
        </Popover>
      );
    }
    let loyaltyCardModal = this.state.loyaltyCardModal ? (
      <div>
        <Modal
          show={this.state.loyaltyCardModal}
          onHide={this.closeLoyaltyCardModal.bind(this)}
          animation={true}
          bsSize="small"
          backdrop={false}
          keyboard={false}
          className="loyaltyCardModal"
        >
          <Modal.Header closeButton />
          <Modal.Body style={{ display: 'inline-block' }}>
            <div className="form-group" className="loyaltyCardBody">
              <span>
                <FormattedMessage
                  id="existingLoyaltyCard"
                  defaultMessage={defaultMsg.existingLoyaltyCard}
                />
                :
              </span>
            </div>
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                value={this.state.loyaltyCardData.number}
                style={{ textAlign: 'center' }}
                disabled
              />
            </div>
            <div className="form-group" style={{ textAlign: 'center' }}>
              <span>
                <FormattedMessage
                  id="balance"
                  defaultMessage={defaultMsg.balance}
                />
                : {this.state.loyaltyCardData.details.loyality_points}{' '}
                <FormattedMessage
                  id="points"
                  defaultMessage={defaultMsg.points}
                />
              </span>
            </div>
            <div className="form-group">
              <hr />
            </div>
            <div className="form-group">
              <div className="row">
                <div
                  className="col-lg-6 col-md-6 col-sm-6 col-xs-6"
                  style={{ textAlign: 'center' }}
                >
                  <span>
                    <FormattedMessage
                      id="discounts"
                      defaultMessage={defaultMsg.discounts}
                    />
                    :
                  </span>
                </div>
                <div
                  className="col-lg-6 col-md-6 col-sm-6 col-xs-6"
                  style={{ textAlign: 'center' }}
                >
                  <span>
                    <FormattedMessage
                      id="award"
                      defaultMessage={defaultMsg.award}
                    />
                    :
                  </span>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div
                  className="col-lg-6 col-md-6 col-sm-6 col-xs-6"
                  style={{ textAlign: 'center' }}
                >
                  <span>
                    {this.state.loyaltyCardData.details.discounttypes.length}
                  </span>
                </div>
                <div
                  className="col-lg-6 col-md-6 col-sm-6 col-xs-6"
                  style={{ textAlign: 'center' }}
                >
                  <span>{this.state.loyaltyCardData.details.awardpoints}</span>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div
                  className="col-lg-6 col-md-6 col-sm-6 col-xs-6"
                  style={{ textAlign: 'center' }}
                >
                  {this.state.currentTimeCompare &&
                  this.state.isNowAvialable &&
                  this.state.loading === loadingStates['loyality'] ? (
                    <Button ref="target">
                      <FormattedMessage
                        id="loadingText"
                        defaultMessage={defaultMsg.loadingText}
                      />
                    </Button>
                  ) : (
                    <Button
                      ref="target"
                      onClick={this.toggleLoyaltyPopover.bind(this)}
                      className="btn btn-default inactive"
                    >
                      <FormattedMessage
                        id="selectDiscountButton"
                        defaultMessage={defaultMsg.selectDiscountButton}
                      />
                    </Button>
                  )}

                  <Overlay
                    placement="top"
                    show={this.state.showLoyaltyPopover}
                    onHide={() => this.setState({ showLoyaltyPopover: false })}
                    target={() => ReactDOM.findDOMNode(this.refs.target)}
                  >
                    {popoverTop}
                  </Overlay>
                </div>
                <div
                  className="col-lg-6 col-md-6 col-sm-6 col-xs-6"
                  style={{ textAlign: 'center', right: '15px' }}
                >
                  <Button
                    className="btn btn-default inactive"
                    onClick={e => this.handleAwardPoint(false, e)}
                  >
                    <FormattedMessage
                      id="awardPointsButton"
                      defaultMessage={defaultMsg.awardPointsButton}
                    />
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    ) : null;
    const awardPointModal =
      this.state.awardPointModal && this.state.loyaltyCardData ? (
        <AwardPointModal data={this.state.loyaltyCardData} open={true} />
      ) : null;

    const giftCardModal = this.state.giftCardModal ? (
      <GiftCardModal
        status={this.state.giftCardModal}
        closeGiftCardModal={() => this.closeGiftCardModal}
        giftCardData={this.state.giftCardData}
        handleGiftCardDiscount={() => this.handleGiftCardDiscount}
        parsePrice={amount => parsePrice(amount)}
      />
    ) : null;

    const noPaymentOptionAvailable = this.noPaymentOptionAvailable();
    const isMultiplePaymentOptionAvailable =
      this.isMultiplePaymentOptionAvailable() && !noPaymentOptionAvailable;

    return (
      <div id="place-order">
        {window.innerWidth <= 768 && !this.props.showMobileSidebar ? (
          <div className="checkout-cart" onClick={this.openCart}>
            <span className="glyphicon glyphicon-shopping-cart" />
            {this.props.dashboardData.numberOfItemsInCart}
          </div>
        ) : null}
        <h4>
          <b>
            <FormattedMessage
              id="placeOrder"
              defaultMessage={defaultMsg.placeOrder}
            />
          </b>
        </h4>

        {this.state.showOutOfStock !== false ? (
          <OutOfStockItems
            outOfStockItems={this.state.showOutOfStock}
            rname={this.props.rname}
            proccedToCheckout={this.proccedToCheckout}
            close={this.hideInventoryOutOfStock}
            show={true}
          />
        ) : null}
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="checkout_container"
          className="toast-top-right"
        />

        {this.state.placingOrder ? (
          <FormattedMessage
            id="redirecting"
            defaultMessage={defaultMsg.redirecting}
          />
        ) : this.props.orderItems.length === 0 ? (
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              <p className=" alert alert-danger">
                <span>
                  <FormattedMessage
                    id="yourCartIsEmpty"
                    defaultMessage={defaultMsg.yourCartIsEmpty}
                  />
                </span>
              </p>
            </div>
          </div>
        ) : this.props.orderTypeSplit &&
        this.props.orderTypeSplit.length < 1 ? (
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              <p className=" alert alert-danger">
                <span>
                  <FormattedMessage
                    id="somethingWentWrong"
                    defaultMessage={defaultMsg.somethingWentWrong}
                  />
                  <FormattedMessage
                    id="pleaseTryTo"
                    defaultMessage={defaultMsg.pleaseTryTo}
                  />
                  <FormattedMessage
                    id="reloadAgain"
                    defaultMessage={defaultMsg.reloadAgain}
                  />
                </span>
              </p>
            </div>
          </div>
        ) : (
          <div>
            <div>
              {loyaltyCardModal}
              {awardPointModal}
              {giftCardModal}
            </div>
            <div className="row small">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                {isMultiplePaymentOptionAvailable ? (
                  <FormattedMessage
                    id="reviewYourOrder"
                    defaultMessage={defaultMsg.reviewYourOrder}
                  />
                ) : (
                  <div>
                    {this.isOnlyMealPlanEnabled() ? (
                      <FormattedMessage
                        id="reviewYourOrderWithMealplanPaymentOffered"
                        defaultMessage={
                          defaultMsg.reviewYourOrderWithMealplanPaymentOffered
                        }
                      />
                    ) : (
                      <FormattedMessage
                        id="reviewYourOrderWithOnePaymentOffered"
                        defaultMessage={
                          defaultMsg.reviewYourOrderWithOnePaymentOffered
                        }
                      />
                    )}
                  </div>
                )}
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <mark className="mark-style">*</mark>
                <FormattedMessage
                  id="denotesRequiredField"
                  defaultMessage={defaultMsg.denotesRequiredField}
                />
              </div>
            </div>

            <form className="checkout-form row">
              {this.props.orderTypeSplit.length > 0 ? (
                <div className="order-information">
                  <div className="formField col-md-9 col-lg-9 col-sm-12 col-xs-12">
                    <h5 className="secondaryFont">
                      <b>
                        <FormattedMessage
                          id="orderInformation"
                          defaultMessage={defaultMsg.orderInformation}
                        />
                      </b>
                    </h5>
                  </div>
                  <div className="col-md-9 col-lg-9 col-sm-12 col-xs-12">
                    {this.props.orderTypeSplit.indexOf('pickup') !== -1 ? (
                      <div
                        className={`btn btn-success diningButton col-md-2 marginBtwButtons ${
                          this.props.dashboardData.modeOfOrder === 1
                            ? 'active'
                            : ''
                        }`}
                        onClick={this.changeDiningOption.bind(this, 1)}
                      >
                        <span>
                          <FormattedMessage
                            id="pickup"
                            defaultMessage={defaultMsg.pickup}
                          />
                        </span>
                      </div>
                    ) : null}
                    {this.props.orderTypeSplit.indexOf('delivery') !== -1 ? (
                      <div
                        className={`btn btn-success diningButton marginBtwButtons col-md-2 ${
                          this.props.dashboardData.modeOfOrder === 2
                            ? 'active'
                            : ''
                        }`}
                        onClick={this.changeDiningOption.bind(this, 2)}
                      >
                        <span>
                          <FormattedMessage
                            id="delivery"
                            defaultMessage={defaultMsg.delivery}
                          />
                        </span>
                      </div>
                    ) : null}
                    {this.props.orderTypeSplit.indexOf('dine-in') !== -1 ? (
                      <div
                        className={`btn btn-success diningButton marginBtwButtons col-md-2 ${
                          this.props.dashboardData.modeOfOrder === 3
                            ? 'active'
                            : ''
                        }`}
                        onClick={this.changeDiningOption.bind(this, 3)}
                      >
                        <span>
                          <FormattedMessage
                            id="dineIn"
                            defaultMessage={defaultMsg.dineIn}
                          />
                        </span>
                      </div>
                    ) : null}
                  </div>
                  {this.props.dashboardData.modeOfOrder !== 2 ? (
                    <OrderDateAndTime
                      orderTypes={this.props.orderTypeSplit}
                      modeOfOrder={GetOrderType(
                        this.props.dashboardData.modeOfOrder
                      )}
                    />
                  ) : null}
                </div>
              ) : null}
              {((this.props.maxAdvanceDays === '0' &&
                this.state.isNowAvialable === false &&
                this.state.currentTimeCompare === false) ||
                (this.props.asapTimeAvailability === '1' &&
                  this.state.isNowAvialable === false)) &&
              !this.isDeliveryModeSelected() ? (
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 formField">
                  <span className="label label-danger">
                    <FormattedMessage
                      id="restaurantNotAcceptingOrder"
                      defaultM
                      essage={defaultMsg.restaurantNotAcceptingOrder}
                    />
                  </span>
                </div>
              ) : (
                this.displayOrderTime(orderTypeText, true)
              )}
              {this.isDeliveryModeSelected() &&
              !this.props.isDataNameFilterForDining ? (
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 primaryColor primaryFont formField">
                  <span className="label label-success">
                    <FormattedMessage
                      id="estimated"
                      defaultMessage={defaultMsg.estimated}
                    />
                    {orderTypeText}
                    &nbsp;
                    <FormattedMessage
                      id="time"
                      defaultMessage={defaultMsg.time}
                    />
                    : &nbsp;
                    {this.props.dashboardData.locationDetails.deliveryTime}
                  </span>
                </div>
              ) : this.isDeliveryModeSelected() &&
              !this.isRestaurantAvailableForDelivery() ? (
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 formField">
                  <div className="label label-danger ">
                    <FormattedMessage
                      id="restaurantNotAcceptingOrder"
                      defaultMessage={defaultMsg.restaurantNotAcceptingOrder}
                    />
                  </div>
                </div>
              ) : null}
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 formField">
                <div className="row" ref="row0">
                  <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                    <div>
                      <span className="primaryFont">
                        <FormattedMessage
                          id="any"
                          defaultMessage={defaultMsg.any}
                        />
                        {orderTypeText}
                        &nbsp;
                        <FormattedMessage
                          id="instructions"
                          defaultMessage={defaultMsg.instructions}
                        />
                        ?
                      </span>
                    </div>
                    <div>
                      <textarea
                        ref="instructions"
                        type="text"
                        required
                        className="form-control"
                        id="instructions"
                        placeholder={
                          orderTypeText +
                          ' ' +
                          this.props.intl.formatMessage({
                            id: 'instructions',
                            defaultMessage: defaultMsg.instructions,
                          })
                        }
                        onChange={this.instructionsOnchange}
                        value={this.state.instructions}
                      />
                    </div>
                    {this.state.instructionsError ? (
                      <ErrorMessage
                        message={{
                          id: 'instructionError',
                          default: defaultMsg.instructionError,
                        }}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12">
                <div className=" formField">
                  <div
                    className="col-lg-9 col-md-9 col-sm-12 col-xs-12"
                    style={{ padding: '0px' }}
                  >
                    <h5 className="secondaryFont">
                      <b>
                        <FormattedMessage
                          id="yourInformation"
                          defaultMessage={defaultMsg.yourInformation}
                        />
                      </b>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                <div className="row" ref="row1">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div>
                      <span className="primaryFont">
                        <FormattedMessage
                          id="firstName"
                          defaultMessage={defaultMsg.firstName}
                        />
                        <mark className="mark-style"> * </mark>
                      </span>
                    </div>

                    <div>
                      <input
                        ref="firstName"
                        type="text"
                        id="firstName"
                        onChange={this.firstNameOnchange}
                        required
                        className="form-control"
                        placeholder={this.props.intl.formatMessage({
                          id: 'placeholderEnterFirstName',
                          defaultMessage: defaultMsg.placeholderEnterFirstName,
                        })}
                        value={this.state.firstName}
                      />
                    </div>
                    {this.state.firstNameError ? (
                      <ErrorMessage
                        message={{
                          id: 'errorFirstName',
                          default: defaultMsg.errorFirstName,
                        }}
                      />
                    ) : null}
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div>
                      <span className="primaryFont">
                        <FormattedMessage
                          id="lastName"
                          defaultMessage={defaultMsg.lastName}
                        />
                        <mark className="mark-style"> * </mark>
                      </span>
                    </div>
                    <div>
                      <input
                        ref="lastName"
                        type="text"
                        required
                        className="form-control"
                        id="lastName"
                        placeholder={this.props.intl.formatMessage({
                          id: 'placeholderEnterLastName',
                          defaultMessage: defaultMsg.placeholderEnterLastName,
                        })}
                        onChange={this.lastNameOnchange}
                        value={this.state.lastName}
                      />
                    </div>
                    {this.state.lastNameError ? (
                      <ErrorMessage
                        message={{
                          id: 'errorLastName',
                          default: defaultMsg.errorLastName,
                        }}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="row" ref="row2">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div>
                      <span className="primaryFont">
                        <FormattedMessage
                          id="telephoneNumber"
                          defaultMessage={defaultMsg.telephoneNumber}
                        />
                        <mark className="mark-style"> *</mark>
                      </span>
                    </div>

                    <div>
                      <input
                        ref="phoneNumber"
                        type="tel"
                        id="phonenumber"
                        onChange={this.phoneNumberOnchange}
                        required
                        className="form-control"
                        placeholder={this.props.intl.formatMessage({
                          id: 'placeholderEnterTelephoneNumber',
                          defaultMessage:
                            defaultMsg.placeholderEnterTelephoneNumber,
                        })}
                        value={this.state.phonenumber}
                      />
                    </div>
                    {this.state.phoneNoError ? (
                      <ErrorMessage
                        message={{
                          id: 'errorTelephoneNumber',
                          default: defaultMsg.errorTelephoneNumber,
                        }}
                      />
                    ) : null}
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div>
                      <span className="primaryFont">
                        <FormattedMessage
                          id="emailAddress"
                          defaultMessage={defaultMsg.emailAddress}
                        />
                        <mark className="mark-style"> *</mark>
                      </span>
                    </div>
                    <div>
                      <input
                        ref="email"
                        type="email"
                        required
                        className="form-control"
                        id="Email"
                        placeholder={this.props.intl.formatMessage({
                          id: 'placeholderEnterEmailAddress',
                          defaultMessage:
                            defaultMsg.placeholderEnterEmailAddress,
                        })}
                        onChange={this.emailOnchange}
                        value={this.state.email}
                      />
                    </div>
                    {this.state.emailError ? (
                      <ErrorMessage
                        message={{
                          id: 'errorEmailAddress',
                          default: defaultMsg.errorEmailAddress,
                        }}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              {this.props.dashboardData.merchantDetails.lavu_gift_card_status ==
              'true' ? (
                <div>
                  <div className="formField col-lg-9 col-md-9 col-sm-12 col-xs-12">
                    <h5 className="secondaryFont">
                      <b>
                        <FormattedMessage
                          id="giftCardPromos"
                          defaultMessage={defaultMsg.giftCardPromos}
                        />
                      </b>
                    </h5>
                  </div>
                  <div className="row">
                    <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div>
                          <span className="primaryFont">
                            <FormattedMessage
                              id="loyaltyCardNumber"
                              defaultMessage={defaultMsg.loyaltyCardNumber}
                            />
                          </span>
                        </div>
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            ref="cardNumber"
                            onChange={this.handleLoyaltyCardChange}
                            placeholder={this.props.intl.formatMessage({
                              id: 'placeholderLoyaltyCardNumber',
                              defaultMessage:
                                defaultMsg.placeholderLoyaltyCardNumber,
                            })}
                            defaultValue={
                              discountDetails ? discountDetails.cardNumber : ''
                            }
                          />
                          {discountDetails ? (
                            <span
                              className="primaryFont"
                              style={{ color: 'green' }}
                            >
                              {this.state.loading ===
                              loadingStates['loyality'] ? (
                                <MdLoaderTheme size={30} />
                              ) : (
                                <span>
                                  {discountDetails.title}
                                  <span
                                    onClick={this.clearDiscount}
                                    className="fa fa-times pull-right remove-discount"
                                  />
                                </span>
                              )}
                            </span>
                          ) : null}
                          <div
                            className="apply no-selection"
                            onClick={e => this.handleLoyaltyPoint(false, e)}
                          >
                            <span className="change-adr-text">
                              {this.state.currentTimeCompare &&
                              this.state.isNowAvialable &&
                              this.state.loading ===
                                loadingStates['loyality'] ? (
                                <span>
                                  {this.props.intl.formatMessage({
                                    id: 'loadingText',
                                    defaultMessage: defaultMsg.loadingText,
                                  })}
                                </span>
                              ) : (
                                <span>
                                  {!this.isDiscountSelected()
                                    ? this.props.intl.formatMessage({
                                        id: 'apply',
                                        defaultMessage: defaultMsg.apply,
                                      })
                                    : this.props.intl.formatMessage({
                                        id: 'edit',
                                        defaultMessage: defaultMsg.edit,
                                      })}
                                </span>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {!this.isOnlyMealPlanEnabled() && !this.state.updatingPayment ? (
                <div className="formField col-lg-9 col-md-9 col-sm-12 col-xs-12">
                  <h5 className="secondaryFont">
                    <b>
                      <FormattedMessage
                        id="paymentInformation"
                        defaultMessage={defaultMsg.paymentInformation}
                      />
                    </b>
                  </h5>
                </div>
              ) : null}

              {this.props.restaurantDetails.isTipEnabled &&
              this.state.paymentMode !== 'meal_plan' ? (
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <span className="primaryFont">
                        <FormattedMessage
                          id="addTip"
                          defaultMessage={defaultMsg.addTip}
                        />
                      </span>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div
                        className={`btn btn-success diningButton col-md-1 col-lg-1 col-sm-2 col-xs-2 marginBtwButtons ${
                          this.state.addTip === '15' ? 'active' : ''
                        }`}
                        onClick={this.handleAddTip.bind(this, '15')}
                      >
                        <span>
                          <FormattedMessage
                            id="tip15"
                            defaultMessage={defaultMsg.tip15}
                          />
                          <FormattedMessage
                            id="percent"
                            defaultMessage={defaultMsg.percent}
                          />
                        </span>
                      </div>
                      <div
                        className={`btn btn-success diningButton marginBtwButtons col-md-1 col-lg-1 col-sm-2 col-xs-2 ${
                          this.state.addTip === '20' ? 'active' : ''
                        }`}
                        onClick={this.handleAddTip.bind(this, '20')}
                      >
                        <span>
                          <FormattedMessage
                            id="tip20"
                            defaultMessage={defaultMsg.tip20}
                          />
                          <FormattedMessage
                            id="percent"
                            defaultMessage={defaultMsg.percent}
                          />
                        </span>
                      </div>
                      <div
                        className={`btn btn-success diningButton marginBtwButtons col-md-1 col-lg-1 col-sm-2 col-xs-2 ${
                          this.state.addTip === '25' ? 'active' : ''
                        }`}
                        onClick={this.handleAddTip.bind(this, '25')}
                      >
                        <span>
                          <FormattedMessage
                            id="tip25"
                            defaultMessage={defaultMsg.tip25}
                          />
                          <FormattedMessage
                            id="percent"
                            defaultMessage={defaultMsg.percent}
                          />
                        </span>
                      </div>
                      <div
                        className={`btn btn-success diningButton marginBtwButtons col-md-1 col-lg-1 col-sm-2 col-xs-2 ${
                          this.state.addTip === '30' ? 'active' : ''
                        }`}
                        onClick={this.handleAddTip.bind(this, '30')}
                      >
                        <span>
                          <FormattedMessage
                            id="tip30"
                            defaultMessage={defaultMsg.tip30}
                          />
                          <FormattedMessage
                            id="percent"
                            defaultMessage={defaultMsg.percent}
                          />
                        </span>
                      </div>
                      <div
                        className={`btn btn-success diningButton marginBtwButtons col-md-1 col-lg-1 col-sm-3 col-xs-2 ${
                          this.state.addTip === 'notip' ? 'active' : ''
                        }`}
                        onClick={this.handleAddTip.bind(this, 'notip')}
                      >
                        <span>
                          <FormattedMessage
                            id="noTip"
                            defaultMessage={defaultMsg.noTip}
                          />
                        </span>
                      </div>
                      <div
                        className={`btn btn-success diningButton marginBtwButtons col-md-2 col-lg-2 col-sm-3 col-xs-4 ${
                          this.state.addTip === 'custom' ? 'active' : ''
                        }`}
                        onClick={this.handleAddTip.bind(this, 'custom')}
                      >
                        <span>
                          <FormattedMessage
                            id="customTip"
                            defaultMessage={defaultMsg.customTip}
                          />
                        </span>
                      </div>
                      {this.state.addTip === 'custom' ? (
                        <div
                          style={{ marginTop: '10px' }}
                          className="col-md-2 col-lg-2 col-sm-2 col-xs-4"
                        >
                          <input
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage({
                              id: 'tipAmount',
                              defaultMessage: defaultMsg.tipAmount,
                            })}
                            value={this.state.customTip}
                            onChange={this.customTipChange}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}

              {isMultiplePaymentOptionAvailable ? (
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 formField">
                  <span className="primaryFont">
                    <FormattedMessage
                      id="paymentMethod"
                      defaultMessage={defaultMsg.paymentMethod}
                    />
                    <mark className="mark-style"> *</mark>
                  </span>
                </div>
              ) : null}

              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {isMultiplePaymentOptionAvailable &&
                this.isCardOptionEnabled() ? (
                  <button
                    className={`btn btn-success diningButton col-md-2 marginBtwButtons ${
                      this.state.paymentMode === 'paypal' ? 'active' : ''
                    }`}
                    onClick={this.handlePaymentMode.bind(this, 'paypal')}
                    disabled={!this.isOrderTimeValid()}
                    type="button"
                  >
                    <span>
                      <FormattedMessage
                        id="payWithCreditCard"
                        defaultMessage={defaultMsg.payWithCreditCard}
                      />
                    </span>
                  </button>
                ) : null}

                {this.props.isPaymentUponRecieptOnly &&
                isMultiplePaymentOptionAvailable &&
                !this.state.updatingPayment ? (
                  <button
                    className={`btn btn-success diningButton marginBtwButtons col-md-2 ${
                      this.state.paymentMode === 'cod' ? 'active' : ''
                    }`}
                    onClick={this.handlePaymentMode.bind(this, 'cod')}
                    disabled={
                      this.state.currentTimeCompare === false &&
                      this.state.isNowAvialable === false &&
                      this.props.maxAdvanceDays === '0'
                        ? true
                        : false
                    }
                    type="button"
                  >
                    <span>
                      {Number(this.props.dashboardData.modeOfOrder) === 2 ? (
                        <FormattedMessage
                          id="cod"
                          defaultMessage={defaultMsg.cod}
                        />
                      ) : null}

                      {Number(this.props.dashboardData.modeOfOrder) === 1 ? (
                        <FormattedMessage
                          id="payAtPickup"
                          defaultMessage={defaultMsg.payAtPickup}
                        />
                      ) : null}

                      {Number(this.props.dashboardData.modeOfOrder) === 3 ? (
                        <FormattedMessage
                          id="payAtDineIn"
                          defaultMessage={defaultMsg.payAtDineIn}
                        />
                      ) : null}
                    </span>
                  </button>
                ) : null}
                {this.props.loginUserDetails &&
                isMultiplePaymentOptionAvailable &&
                this.isMealPlanEnabled()
                  ? this.renderMealPlanButton()
                  : null}
              </div>
              {this.state.updatingPayment ? (
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 formField">
                  <FormattedMessage
                    id="loadingText"
                    defaultMessage={defaultMsg.loadingText}
                  />
                </div>
              ) : null}

              {(this.props.maxAdvanceDays === '0' &&
                this.state.isNowAvialable === false &&
                this.state.currentTimeCompare === false) ||
              (this.props.asapTimeAvailability === '1' &&
                this.state.isNowAvialable === false) ? (
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 formField">
                  <span className="label label-danger">
                    <FormattedMessage
                      id="restaurantNotAcceptingOrder"
                      defaultMessage={defaultMsg.restaurantNotAcceptingOrder}
                    />
                  </span>
                </div>
              ) : null}

              {this.renderPaymentSection()}

              {/* <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 alignCenter formField1">
                <Footer />
              </div> */}
            </form>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dashboardData: getDashboardData(state),
    loginUserDetails: getUserDetails(state),
    tokenId: getTokenId(state),
    jwt: getJWT(state),
    checkoutData: checkoutData(state),
    restaurantDetails: getRestaurantDetails(state),
    orderDetails: getOrderDetails(state),
    discount: state.checkout.discount,
    isDataNameFilterForDining: isDataNameFilterForDining(state),
    showMobileSideBar: state.dashboard.showMobileSideBar,
    isPaymentUponRecieptOnly: isPaymentUponRecieptOnly(state),
    isPrepayOnly: isPrepayOnly(state),
    isNotValidPaymentOptions: isNotValidPaymentOptions(state),
    dataname: state.dashboard.dataName,
    asapTimeAvailability:
      state.dashboard.merchantDetails.enable_allow_asap_orders_2,
    maxAdvanceDays: state.dashboard.merchantDetails.max_advance_days_2,
    rtd: state.rtd.status,
  };
}

PlaceOrder.propTypes = {
  intl: intlShape.isRequired,
};

export default connect(mapStateToProps)(injectIntl(PlaceOrder));



// WEBPACK FOOTER //
// ./src/views/checkout/components/PlaceOrder.jsx